import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagBookingPortalsPage } from 'src/app/model/page/group/iag-portal/iag-booking-portals-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-booking-portals-page',
  templateUrl: './iag-booking-portals-page.component.html',
  styleUrls: ['./iag-booking-portals-page.component.scss']
})
export class IagBookingPortalsPageComponent implements OnInit {
  iagBookingPortalsPage: IagBookingPortalsPage = {} as IagBookingPortalsPage;
  isIagPotalPage = false;
  iagRevisionNoticeTitle: string = '';
  iagLatestAPIProductUpdates: string = '';
  iagRevisionNoticeButton: string = '';
  iagRevisionNoticeUrl: string = '';
  readonly MAX_ENTRIES_TABLE: number = 5;
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-booking-portal-suport') {
        this.iagBookingPortalsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagBookingPortalsPage.sections = [];
    this.iagBookingPortalsPage.aboveIagTableSection = [];
    this.iagBookingPortalsPage.belowIagTableSection = [];
    this.iagBookingPortalsPage.benefitCards = [];
    this.iagBookingPortalsPage.iagPortalRevisionNotices = [];

    const query = { 'fields.title': 'IAG Booking Portals Support' };

    this.contentfulService.getPageContentResponse(query).then((iagBookingPortalsPageEntries) => {
      this.mapBanner(iagBookingPortalsPageEntries.includes.Entry);
      this.mapNewsCardLabels();
      this.mapPageInfo(iagBookingPortalsPageEntries.items);
      this.sharedDataService.addSharedData(this.iagBookingPortalsPage.banner);
      this.mapSections(iagBookingPortalsPageEntries.includes.Entry);
      this.mapTableSection(iagBookingPortalsPageEntries.includes.Entry);
      this.mapCards(iagBookingPortalsPageEntries.includes.Entry);
    });
    this.contentfulService.getIagRevisionNoticePageResponse().then((iagRevisionEntries) => {
      this.mapPages(iagRevisionEntries);
    });
  }
  private mapPages(iagRevisionEntries: Entry<any>[]) {
    iagRevisionEntries
      .filter((entry) => ModelValidator.isPage(entry) || ModelValidator.isIagProductUpdateNotification(entry))
      .forEach((entry) => {
        this.mapEntryToIagRevisionNotice(entry);
      });
    this.iagPortalUpdateNotificationTitleFormat();
  }

  private iagPortalUpdateNotificationTitleFormat() {
    let maxEntries: number = this.iagBookingPortalsPage.iagPortalRevisionNotices.length < this.MAX_ENTRIES_TABLE ? this.iagBookingPortalsPage.iagPortalRevisionNotices.length : this.MAX_ENTRIES_TABLE;
    let firstDate = new Date(this.iagBookingPortalsPage.iagPortalRevisionNotices[0].liveDate);
    let secondDate = new Date(this.iagBookingPortalsPage.iagPortalRevisionNotices[maxEntries - 1].liveDate);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long'
    };
    if (typeof firstDate !== 'undefined' && typeof secondDate !== 'undefined') {
      let formattedFirstDate = firstDate.toLocaleDateString('en-US', options);
      let formattedSecondDate = secondDate.toLocaleDateString('en-US', options);
      if (firstDate.getMonth() + firstDate.getFullYear() === secondDate.getMonth() + secondDate.getFullYear()) {
        this.iagRevisionNoticeTitle = `${formattedSecondDate}`;
      } else if (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() !== secondDate.getMonth()) {
        this.iagRevisionNoticeTitle = `${formattedFirstDate.split(' ')[0]} - ${formattedSecondDate}`;
      } else {
        this.iagRevisionNoticeTitle = `${formattedFirstDate} - ${formattedSecondDate}`;
      }
    }
  }

  private mapEntryToIagRevisionNotice(entry: Entry<any>) {
    if (
      (typeof entry.fields['liveDate'] !== 'undefined' &&
        typeof entry.fields['status'] !== 'undefined' &&
        typeof entry.fields['title'] !== 'undefined' &&
        typeof entry.fields['url'] !== 'undefined') ||
      typeof entry.fields['htmlTitle'] !== 'undefined'
    ) {
      this.iagBookingPortalsPage.iagPortalRevisionNotices.push({
        liveDate: entry.fields['liveDate'] as string,
        status: entry.fields['status'] as string,
        title: (entry.fields['title'] || entry.fields['htmlTitle']) as string,
        url: entry.fields['url'] as string
      });
      this.iagBookingPortalsPage.iagPortalRevisionNotices?.sort((a, b) => b.liveDate.localeCompare(a.liveDate));
      this.iagBookingPortalsPage.iagPortalRevisionNotices.splice(5);
    }
  }
  private mapBanner(iagBookingPortalsPageEntries: Entry<any>[]) {
    iagBookingPortalsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.iagBookingPortalsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(iagBookingPortalsPageEntries: Entry<any>[]) {
    iagBookingPortalsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'above-iag-updates-table':
            this.mapEntryToAboveIagTableSection(entry);
            break;
          case 'below-iag-updates-table':
            this.mapEntryToBelowIagTableSection(entry);
            break;
          default:
            // console.log('cannot find a group name');
            break;
        }
        this.mapEntryToSection(entry);
      });

    this.iagBookingPortalsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagBookingPortalsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagBookingPortalsPage.banner.url = entry.fields?.url;
      this.iagBookingPortalsPage.banner.editorEmail = editorDetails?.pop();
      this.iagBookingPortalsPage.banner.editorShortName = editorDetails?.pop();
      this.iagBookingPortalsPage.banner.editorFullName = editorDetails?.pop();
      this.iagBookingPortalsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapEntryToSection(entry: Entry<any>) {
    let title = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop() as string;
    this.iagBookingPortalsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      sectionClass: entry.fields['sectionClass'] as string
    });
  }
  private mapEntryToAboveIagTableSection(entry: Entry<any>) {
    let title = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop() as string;
    this.iagBookingPortalsPage.aboveIagTableSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      sectionClass: entry.fields['sectionClass'] as string
    });
  }
  private mapEntryToBelowIagTableSection(entry: Entry<any>) {
    let title = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop() as string;
    this.iagBookingPortalsPage.belowIagTableSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      sectionClass: entry.fields['sectionClass'] as string
    });
  }

  private mapCards(iagPortalPageEntries: any[]) {
    iagPortalPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.mapEntryToBenefitCard(entry);
      });
  }

  private mapEntryToBenefitCard(entry: Entry<any>) {
    let givenHeaderImage: any = entry.fields['headImage'];
    let body: any = entry.fields['body'];
    this.iagBookingPortalsPage.benefitCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      headImage: givenHeaderImage.fields?.file?.url as string,
      headIconClass: entry.fields['headIconClass'] as string,
      body: body.content[0]?.content[0]?.value as string
    });
    this.iagBookingPortalsPage.benefitCards.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(iagBookingPortalsPageEntries: Entry<any>[]) {
    iagBookingPortalsPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }
  private mapEntryToTableSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
  }

  private mapNewsCardLabels() {
    const query = { 'fields.title': 'IAG Booking Portals Support' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      this.iagLatestAPIProductUpdates = labelItems[0]?.fields.constants[0].iagLatestAPIProductUpdates;
      this.iagRevisionNoticeButton = labelItems[0]?.fields.constants[1].iagRevisionNoticeButton;
      this.iagRevisionNoticeUrl = labelItems[0]?.fields.constants[1].iagRevisionNoticeUrl;
    });
  }
}
